import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { ClientConfiguration } from '../../datasource/generated';

export type ClientConfigState = Partial<ClientConfiguration>;

const initialState: ClientConfigState = {};

const clientConfigSlice = createSlice({
    name: 'clientConfig',
    initialState,
    reducers: {
        setClientConfig: (_state, action: PayloadAction<ClientConfiguration>) => {
            return { ...action.payload };
        },
    },
});

export const { setClientConfig } = clientConfigSlice.actions;
export const { reducer: clientConfigReducer } = clientConfigSlice;
